import { useQuery } from "react-query";
import { getCommisionOfPayments } from "../../../../actions/CarrierAgreementMgmt/Agreements";

export const useGetCommisionOfPayments = () => {
  return useQuery("GetCommisionOfPayments", getCommisionOfPayments, {
    refetchOnWindowFocus: false,
  });
};
